var exports = {
  "iE": "xaee3c4fa--d779b9--wrapper",
  "Qs": "xaee3c4fa--d779b9--content",
  "A1": "xaee3c4fa--d779b9--_active",
  "nf": "xaee3c4fa--d779b9--link",
  "rL": "xaee3c4fa--d779b9--author-link",
  "ho": "xaee3c4fa--d779b9--user-card-wrapper",
};

module.exports = exports;
